/* eslint-disable camelcase */
import type { CoreExtraContext, EventProperties } from '@segment/analytics-core';
import type { Plugin } from '@segment/analytics-next';

/*
 * Matches route with reservation group ID, e.g. /reservation/abc-12-34-56-78-90
 * or /reservation/abc-12-34-56-78-90/success
 * or /reservation/abc-12-34-56-78-90/retry-payment
 * or /reservation/abc-12-34-56-78-90/failed, etc.
 */
const reservationGroupIdRegex = /\/reservation\/[a-zA-Z0-9-]+/u;

function maskString(url: string): string {
  try {
    const resultUrl = new URL(url);

    resultUrl.pathname = resultUrl.pathname.replace(reservationGroupIdRegex, '/reservation/MASKED');

    return resultUrl.toString();
  } catch {
    return url;
  }
}

export function removeReservationGroupIdFromPageObject(page: CoreExtraContext['page']): void {
  if (typeof page?.referrer === 'string') {
    page.referrer = page.referrer.replace(reservationGroupIdRegex, '/reservation/MASKED');
  }

  if (typeof page?.path === 'string') {
    page.path = page.path.replace(reservationGroupIdRegex, '/reservation/MASKED');
  }

  if (typeof page?.url === 'string') {
    page.url = page.url.replace(reservationGroupIdRegex, '/reservation/MASKED');
  }

  if (typeof page?.search === 'string') {
    page.search = page.search.replace(reservationGroupIdRegex, '/reservation/MASKED');
  }
}

export function removeReservationGroupIdFromProperties(properties?: EventProperties): void {
  if (typeof properties?.referrer === 'string') {
    properties.referrer = properties.referrer.replace(reservationGroupIdRegex, '/reservation/MASKED');
  }

  if (typeof properties?.path === 'string') {
    properties.path = properties.path.replace(reservationGroupIdRegex, '/reservation/MASKED');
  }

  if (typeof properties?.url === 'string') {
    properties.url = properties.url.replace(reservationGroupIdRegex, '/reservation/MASKED');
  }

  if (typeof properties?.search === 'string') {
    properties.search = properties.search.replace(reservationGroupIdRegex, '/reservation/MASKED');
  }

  // Mask reservation group ID from `action_url` if it exists
  if (typeof properties?.action_url === 'string') {
    properties.action_url = maskString(properties.action_url);
  }
}

const removeReservationGroupIdPlugin: Plugin = {
  name: 'removeReservationGroupIdPlugin',
  version: '1.0.0',
  type: 'before',

  isLoaded() {
    return true;
  },

  async load() {
    // No-op: plugin setup is synchronous
  },

  page(context) {
    removeReservationGroupIdFromPageObject(context.event.context?.page);
    removeReservationGroupIdFromProperties(context.event.properties);

    return context;
  },

  track(context) {
    removeReservationGroupIdFromPageObject(context.event.context?.page);
    removeReservationGroupIdFromProperties(context.event.properties);

    return context;
  },

  identify(context) {
    removeReservationGroupIdFromPageObject(context.event.context?.page);

    return context;
  },

  group(context) {
    removeReservationGroupIdFromPageObject(context.event.context?.page);
    removeReservationGroupIdFromProperties(context.event.properties);

    return context;
  }
};

export {
  removeReservationGroupIdPlugin
};
